import React, { HTMLAttributes } from 'react'

import { ArrowForwardIcon, Box, ProductionListingRow } from '@vividseats/vivid-ui-kit'

import VariantProductionListingRowWithBadging from '@/optimizely/components/variant-production-listing-row-with-badging'
import { useMlbPerformerOpeningDayMobileFeature } from '@/optimizely/features/mlb-performer-opening-day-feature/hooks/use-mlb-performer-opening-day-mobile-feature'
import { useSellingFastDealsAvailableConcertPerformerFeature } from '@/optimizely/features/selling-fast-deals-available-concert-performer-feature/hooks'
import { useSellingFastDealsAvailableSportsHomePerformerFeature } from '@/optimizely/features/selling-fast-deals-available-sports-home-performer-feature/hooks'
import { useSellingFastDealsAvailableSportsPerformerFeature } from '@/optimizely/features/selling-fast-deals-available-sports-performer-feature/hooks'
import { useSellingFastDealsAvailableTheatrePerformerFeature } from '@/optimizely/features/selling-fast-deals-available-theatre-performer-feature/hooks'

import styles from './styles.module.scss'

interface MobileProductionListingRowType extends HTMLAttributes<HTMLAnchorElement> {
    date: string
    day: string
    href: string
    isSellingFast?: boolean
    isLowPricesDealsAvailable?: boolean
    isHomeOpener?: boolean
    location: string
    time: string
    title: string
    venueName: string
}

const MobileProductionListingRow: React.FC<MobileProductionListingRowType> = ({
    isSellingFast,
    isLowPricesDealsAvailable,
    isHomeOpener,
    location,
    venueName,
    children,
    ...props
}) => {
    const [isSellingFastDealsAvailableConcertPerformerFeatureEnabled] =
        useSellingFastDealsAvailableConcertPerformerFeature()
    const [isSellingFastDealsAvailableTheatrePerformerFeatureEnabled] =
        useSellingFastDealsAvailableTheatrePerformerFeature()
    const [isSellingFastDealsAvailableSportsPerformerFeatureEnabled] =
        useSellingFastDealsAvailableSportsPerformerFeature()
    const [isSellingFastDealsAvailableSportsHomePerformerFeatureEnabled] =
        useSellingFastDealsAvailableSportsHomePerformerFeature()
    const isScarcityBadgingMobileFeatureEnabled =
        isSellingFastDealsAvailableConcertPerformerFeatureEnabled ||
        isSellingFastDealsAvailableTheatrePerformerFeatureEnabled ||
        isSellingFastDealsAvailableSportsPerformerFeatureEnabled ||
        isSellingFastDealsAvailableSportsHomePerformerFeatureEnabled

    const [isMlbPerformerOpeningDayMobileFeatureEnabled] = useMlbPerformerOpeningDayMobileFeature()

    const componentProps = {
        children: (
            <>
                {children}
                <Box tabletDisplay="none" alignSelf="center" marginLeft={5}>
                    <ArrowForwardIcon />
                </Box>
            </>
        ),
        classes: styles,
        label: `${venueName} - ${location}`,
        mobileDivider: false,
        titleColumnProps: { ml: 1 },
        ...props,
    }

    return isScarcityBadgingMobileFeatureEnabled || isMlbPerformerOpeningDayMobileFeatureEnabled ? (
        <VariantProductionListingRowWithBadging
            isSellingFast={isSellingFast}
            isLowPricesDealsAvailable={isLowPricesDealsAvailable}
            isHomeOpener={isHomeOpener}
            {...componentProps}
        />
    ) : (
        <ProductionListingRow {...componentProps} />
    )
}

export default MobileProductionListingRow
